import { backgroundColor, neutralFillCardDelta, neutralPalette } from '../fluent-design-system';
import { findClosestSwatchIndex, getSwatch } from './palette';
const neutralCardFillAlgorithm = (designSystem) => {
    const offset = neutralFillCardDelta(designSystem);
    const index = findClosestSwatchIndex(neutralPalette, backgroundColor(designSystem))(designSystem);
    return getSwatch(index - (index < offset ? offset * -1 : offset), neutralPalette(designSystem));
};
/**
 * @internal
 */
export function neutralFillCard(arg) {
    if (typeof arg === 'function') {
        return (designSystem) => {
            return neutralCardFillAlgorithm(Object.assign({}, designSystem, { backgroundColor: arg(designSystem) }));
        };
    }
    else {
        return neutralCardFillAlgorithm(arg);
    }
}
